export default [
  {
    path: '/app/products',
    name: 'Products',
    component: () => import('@/views/Admin/Products/Index.vue'),
    meta: {
      pageTitle: 'Projeler',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_PRODUCTS',
      action: 'read',
    },
  },
  {
    path: '/app/products/add',
    name: 'ProductAdd',
    component: () => import('@/views/Admin/Products/Add.vue'),
    meta: {
      pageTitle: 'Projeler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/products',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_PRODUCTS',
      action: 'read',
    },
  },
  {
    path: '/app/products/edit/:id',
    name: 'ProductEdit',
    component: () => import('@/views/Admin/Products/Edit.vue'),
    meta: {
      pageTitle: 'Projeler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/products',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_PRODUCTS',
      action: 'read',
    },
  },
]
